export const DocumentRecordModalTestIds = {
  CANCEL_BUTTON: 'document-record-modal.cancel-button',
  SAVE_BUTTON: 'document-record-modal.save-button',
};
